"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("./auth");
exports.default = {
    authInterceptor: auth_1.default
};
